export const galleryImages = [
  {
    url: 'https://readdy.ai/api/search-image?query=modern%20retail%20shop%20interior%20wooden%20shelving%20display%20with%20curated%20products%20natural%20light%20warm%20atmosphere%20boutique%20store%20design%20clean%20minimalist%20aesthetic%20plants%20and%20decor%20professional%20interior%20photography&width=500&height=700&seq=gallery-interior-1&orientation=portrait',
    alt: 'Shop Interior Display',
    aspectRatio: '5/7'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=boutique%20shop%20product%20display%20table%20with%20carefully%20arranged%20merchandise%20natural%20materials%20wooden%20surfaces%20plants%20and%20decorative%20items%20warm%20lighting%20cozy%20retail%20environment%20professional%20photography&width=600&height=400&seq=gallery-display-2&orientation=landscape',
    alt: 'Product Display',
    aspectRatio: '3/2'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=retail%20shop%20checkout%20counter%20area%20with%20vintage%20cash%20register%20wooden%20counter%20plants%20and%20warm%20lighting%20welcoming%20service%20area%20boutique%20store%20interior%20professional%20photography&width=500&height=600&seq=gallery-counter-3&orientation=portrait',
    alt: 'Checkout Area',
    aspectRatio: '5/6'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=close%20up%20of%20artisan%20products%20on%20wooden%20shelf%20handmade%20goods%20ceramic%20items%20natural%20materials%20boutique%20retail%20display%20warm%20lighting%20professional%20product%20photography&width=600&height=400&seq=gallery-products-4&orientation=landscape',
    alt: 'Artisan Products',
    aspectRatio: '3/2'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=cozy%20corner%20of%20retail%20shop%20with%20comfortable%20seating%20area%20plants%20books%20and%20decorative%20items%20warm%20inviting%20atmosphere%20boutique%20store%20interior%20natural%20lighting%20professional%20photography&width=500&height=700&seq=gallery-corner-5&orientation=portrait',
    alt: 'Shop Corner',
    aspectRatio: '5/7'
  },
  {
    url: 'https://readdy.ai/api/search-image?query=retail%20shop%20window%20display%20with%20featured%20products%20natural%20light%20streaming%20through%20large%20windows%20plants%20and%20seasonal%20decorations%20boutique%20storefront%20interior%20professional%20photography&width=600&height=400&seq=gallery-window-6&orientation=landscape',
    alt: 'Window Display',
    aspectRatio: '3/2'
  }
];